import { render, staticRenderFns } from "./comUserWx.vue?vue&type=template&id=e88d1f6c&scoped=true&"
import script from "./comUserWx.vue?vue&type=script&lang=js&"
export * from "./comUserWx.vue?vue&type=script&lang=js&"
import style0 from "./comUserWx.vue?vue&type=style&index=0&id=e88d1f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d1f6c",
  null
  
)

export default component.exports